import React, { PropTypes } from 'react';
import Hammer from 'react-hammerjs';
import MainMenu from './MainMenu';
import SecondaryMenu from './SecondaryMenu';

const Menu = (props) => {
  const { lang, edition, handleSwipe } = props;
  return (
    <Hammer onSwipe={handleSwipe} direction="DIRECTION_HORIZONTAL">
      <div className="c-website-menu">
        <MainMenu
          lang={lang} background={edition.background} menu={edition.mainMenu} edition={edition.id}
        />
        <SecondaryMenu lang={lang} menu={edition.secondaryMenu} edition={edition.id} />
        <a className="lang-switch" href={lang === 'ar' ? '/en' : '/ar'}>
          {lang === 'ar' ? 'En' : 'ع'}
        </a>
      </div>
    </Hammer>);
};

Menu.propTypes = {
  edition: PropTypes.shape({
    mainMenu: PropTypes.array,
  }).isRequired,
  lang: PropTypes.string.isRequired,
  handleSwipe: PropTypes.func.isRequired,
};

export default Menu;



// WEBPACK FOOTER //
// ./js/components/menus/Menu.js